export default __webpack_public_path__ + "static/media/7.10850ec7.jpg";